if (!customElements.get('homepage-faq')) {
  customElements.define(
    'homepage-faq',
    class HomepageFaq extends HTMLElement {
      connectedCallback() {
        this.accordions = Array.from(this.querySelectorAll('[data-accordions] details'));
        this.bindAccordions();
      }

      bindAccordions() {
        this.accordions.forEach((details) => {
          const body = details.querySelector('.homepage-faq__accordion-body');
          const summary = details.querySelector('summary');
          if (!body || !summary) return;

          body.style.height = details.open ? `${body.scrollHeight}px` : '0px';

          summary.addEventListener('click', (event) => {
            event.preventDefault();
            if (details.open) {
              this.closeAccordion(details);
              return;
            }
            this.accordions.forEach((other) => {
              if (other !== details && other.open) this.closeAccordion(other);
            });
            this.openAccordion(details);
          });
        });
      }

      openAccordion(details) {
        const body = details.querySelector('.homepage-faq__accordion-body');
        if (!body) return;
        details.setAttribute('open', '');
        body.style.height = '0px';
        requestAnimationFrame(() => {
          body.style.height = `${body.scrollHeight}px`;
        });
        const onEnd = (event) => {
          if (event.propertyName !== 'height') return;
          body.style.height = 'auto';
          body.removeEventListener('transitionend', onEnd);
        };
        body.addEventListener('transitionend', onEnd);
      }

      closeAccordion(details) {
        const body = details.querySelector('.homepage-faq__accordion-body');
        if (!body) return;
        body.style.height = `${body.scrollHeight}px`;
        requestAnimationFrame(() => {
          body.style.height = '0px';
        });
        const onEnd = (event) => {
          if (event.propertyName !== 'height') return;
          details.removeAttribute('open');
          body.removeEventListener('transitionend', onEnd);
        };
        body.addEventListener('transitionend', onEnd);
      }
    }
  );
}
